<script>
	import formBase from '@_system/components/base/form.vue'
	import invoicebox from '@/components/formcomponents/common/box/invoice/index.vue'
	import bankaccbox from './box/bankacc.vue'
	import rcvaccbox from './box/rcvacc.vue'
	import jindieform from './jindie/form.vue'
	import yhzzdform from '@/components/forms/transferaccounts/jindie/yhzzdform.vue'
	import xjzzdform from '@/components/forms/transferaccounts/jindie/xjzzdform.vue'
	import xjcqdform from '@/components/forms/transferaccounts/jindie/xjcqdform.vue'
	import invoiceConfig from '@/components/reports/reconciliationbankflow/lib/invoice/index.vue'
	export default {
		extends: formBase,
		name: 'costorderForm',
		props: {

		},
		data() {
			return {
				costobj:null,
				businessstaffid:null,
				isauto:true,
				hasinvoice:0,
				maindata:null,
				tabledata:[],
				jindierequire:null,
				buyerName:null,
				currentrow:{},
				invoicedata:{}
			}

		},
		render(h) {
			this.$slots.plug = [
				<invoicebox ref = "invoicebox"
				selectType = "radio"
				onBack = {
					this.invoiceboxBack
				}
				onSubmit = {
					this.invoiceboxSubmit
				}
				onBoxdataload = {
					this.invoiceboxdataload
				}
				buyerName  = {this.buyerName}
				/>,
				<bankaccbox ref = "bankaccbox" onBack = {this.bankaccboxBack}
					onSubmit = {this.bankaccboxSubmit}
					isauto = {this.isauto}
					hasinvoice = {this.hasinvoice}
					onBoxdataload = {this.bankaccboxload}/>,
				<rcvaccbox ref = "rcvaccbox" onBack = {this.rcvaccboxBack}
					onSubmit = {this.rcvaccboxSubmit}
					onBoxdataload = {this.rcvaccboxload} costobj = {this.costobj} businessstaffid={this.businessstaffid} />,	
				<jindieform ref = "jindieform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				<yhzzdform ref = "yhzzdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
				<xjzzdform ref = "xjzzdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				<xjcqdform ref = "xjcqdform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
				<invoiceConfig ref="invoiceConfig" invoicedata={this.invoicedata} tab={['invoice']} title="发票预览" />	,
			
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			invoiceboxBack(){
				
			},
			invoiceboxSubmit(e){
				this.currentrow.invoiceNumber = e.data.invoiceNumber
				this.currentrow.invoiceamount = e.data.totalPrice
				this.currentrow.invoiceattr = e.data.invoiceClass == 31?331:7968
				this.currentrow.customerId_system = e.data.customerId
				this.currentrow.invoiceId_system = e.data.invoiceId
				this.currentrow.invoiceType_system = e.data.invoiceType
			},
			invoiceboxdataload(){
				
			},
			beforeSubmit(formData, next) {
				formData.jindierequire = formData.jindierequire?JSON.parse(formData.jindierequire):null
				next()
			},
			beforeRender(sourceData) {
				sourceData.jindierequire = sourceData.jindierequire?JSON.stringify(sourceData.jindierequire):null
			},
			// beforeInit(next){
			// 	next()
			// }
			jindierequireButton(){
				let jindietype = this.fApi.getValue('jindietype')
				if(!jindietype){
					this.$message.error('请选择星空模块')
					return
				}
				let maindata = {}
				maindata.bankAcc = this.fApi.getValue('bankAcc')
				maindata.payAcc = this.fApi.getValue('bankAcc')
				maindata.rcvAcc = this.fApi.getValue('rcvacc')
				maindata.mark = this.fApi.getValue('mark')
				maindata.jindietype = this.fApi.getValue('jindietype')
				let $son_costorder_detail = this.fApi.el('$son_costorder_detail')
				let table = $son_costorder_detail.getGrid()
				let fullData = table.getTableData().fullData
				let costordertype = window.systemData.emun.filter((item)=>{
					return item.field == 'costordertype'
				})
				let tabledata = fullData.map((item)=>{
					let costordertypecode = null
					let target = costordertype.find((_item)=>{
						return _item.id == item.costordertype[item.costordertype.length - 1]
					})
					if(target && target.code){
						costordertypecode = target.code.split('/')[0]
					}
					return {
						id:item.id,
						costordertype:window.systemMethods.getEmunValue('costordertype',item.costordertype),
						costordertypecode:costordertypecode,
						costamount:item.costamount,
						store:item.store,
						businessdepartmentid:item.businessdepartmentid,
						FEXPENSEDEPTID_E:null,
						FCOSTID:null,
						FSETTLETYPEID:null,
						FPURPOSEID:null,
						F_SXTN_DFKM:null,
						F_SXTN_ZZJG:null,
					}			
					
				})
				this.tabledata = tabledata.filter((item)=>{
					return item.id
				})
				this.maindata = maindata
				//console.log(tabledata)
				this.jindierequire = this.fApi.getValue('jindierequire')
				this.$nextTick(()=>{
					if(jindietype == 'AP_PAYBILL' || jindietype == 'AP_REFUNDBILL'){
						this.$refs.jindieform.modal_show()
					}
					if(jindietype == 'CN_BANKTRANSBILL'){
						this.$refs.yhzzdform.modal_show()
					}
					if(jindietype == 'CN_CASHTRANSBILL'){
						this.$refs.xjzzdform.modal_show()
					}
					if(jindietype == 'CN_CASHACCESSBILL'){
						this.$refs.xjcqdform.modal_show()
					}
				})
				
			},
			jindietypeChange(){
				this.fApi.setValue('jindierequire',null)
			},
			jindieformSuccess(e){
				this.fApi.setValue('jindierequire',e.data)
				this.fApi.setValue('jindiestaffid',this.$store.state.system.user.id)
			},
			jindieformClear(){
				this.fApi.setValue('jindierequire',null)
			},
			regestEvent(){
				if(this.id == 0){
					this.fApi.setValue('biztime',this.$Moment().add(1, 'day').startOf('day').valueOf())
				}
				let $son_costorder_detail = this.fApi.el('$son_costorder_detail')
				//console.log($son_costorder_detail)
				$son_costorder_detail.invoice = (row)=>{
					let companyid = this.fApi.getValue('companyid')				
					this.buyerName = window.systemMethods.getcompany(companyid)
					this.currentrow = row
					this.$nextTick(()=>{
						this.$refs.invoicebox.initList()
						this.$refs.invoicebox.box.alertBox()
					})
				}


				$son_costorder_detail.preview = this.preview
			},
			preview(row){
				//console.log(row)
				this.invoicedata = {
					invoiceNumber:row.invoiceno,
					customerId:row.customerId_system,
					invoiceId:row.invoiceId_system,
					invoiceType:row.invoiceType_system
				}
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			bankaccboxBack(){
				
			},
			bankaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('corpCode',e.data.corpCode)
					this.fApi.setValue('bankAcc',e.data.bankAcc)
					this.fApi.setValue('accName',e.data.accName)
				}else{
					this.fApi.setValue('corpCode',null)
					this.fApi.setValue('bankAcc',null)
					this.fApi.setValue('accName',null)
				}
			},
			bankaccboxload(){
				
			},
			rcvaccboxBack(){
				
			},
			rcvaccboxSubmit(e){
				if(e.data){
					this.fApi.setValue('rcvAcc',e.data.rcvAcc.replace(/\s/g, ''))
					this.fApi.setValue('rcvBankName',e.data.rcvBankName)
					this.fApi.setValue('rcvName',e.data.rcvName)
				}
			},
			rcvaccboxload(){
				
			},
			
			hasinvoiceChange(e){
				this.hasinvoice = e
				// this.fApi.setValue('corpCode',null)
				// this.fApi.setValue('bankAcc',null)
				// this.fApi.setValue('accName',null)
			},
			costobjChange(){
				//console.log(this.randerformdata)
				if(!this.randerformdata){
					if(!this.id){
						this.fApi.setValue('rcvAcc',null)
						this.fApi.setValue('rcvBankName',null)
						this.fApi.setValue('rcvName',null)
					}
					// if(e == 9825){					
					// 	this.fApi.setValue('rcvAcc',this.$store.state.system.user.detail.bankcard.replace(/\s/g, ''))
					// 	this.fApi.setValue('rcvBankName',this.$store.state.system.user.detail.bank)
					// 	this.fApi.setValue('rcvName',this.$store.state.system.user.detail.bankaccount)
					// }
				}
			},
			amountChange(){
				if(!this.fApi.getValue('jindierequire')){
					let amount = this.fApi.getValue('amount')
					if(amount > 0){
						this.fApi.setValue('jindietype','AP_PAYBILL')
					}else{
						this.fApi.setValue('jindietype','AP_REFUNDBILL')
					}
				}

			},
			isautoChange(e){
				this.isauto = e
			},
			companyidChange(e){
				if(!this.randerformdata){
					this.getpayaccount(e)
				}
				
			},
			afterGet(res){
				if(res.companyid && !this.fApi.getValue('bankAcc')){
					this.getpayaccount(res.companyid)
				}
			},
			getpayaccount(companyid){
				if(this.id == 0){
					return
				}
				let obj = window.systemData.company.find((item)=>{
					return item.id == companyid
				})
				if(obj){
					this.loading = true
					this.$api.bankaccount.list().then((res) => {						
						let account = res.list.find((item)=>{
							return item.bankAcc == obj.accountnumber
						})						
						if(!account){
							this.$message.error('未查询到公司账户')
							this.loading = false
							return
						}
						this.bankaccboxSubmit({data:account})
						this.loading = false
					},()=>{						
						this.loading = false
					})
					//console.log(obj.accountnumber)
				}else{
					this.bankaccboxSubmit({data:null})
				}
			},
			bankAccButton(){
				this.hasinvoice = this.fApi.getValue('hasinvoice')
				if(!this.isauto){
					this.$message.error('请选择是否财资打款')
					return
				}
				if(!this.hasinvoice){
					this.$message.error('请选择有无发票')
					return
				}
				
				this.$refs.bankaccbox.initList()
				this.$refs.bankaccbox.box.alertBox()
			},
			rcvAccButton(){
				this.costobj = this.fApi.getValue('costobj') 
				this.businessstaffid = this.fApi.getValue('businessstaffid') 
				// if(!this.businessstaffid){
				// 	this.$message.error('请选择业务员')
				// 	return
				// }
				if(!this.costobj){
					this.$message.error('请选择费用对象')
					return
				}				
				this.$refs.rcvaccbox.initList()
				this.$refs.rcvaccbox.box.alertBox()		
			},
			
			
			tablefieldChange() {
				this.getAmount()
			},
			aftertabledelete() {
				this.getAmount()
			},
			getAmount() {
				let $son_costorder_detail = this.fApi.el('$son_costorder_detail')
				let table = $son_costorder_detail.getGrid()
				let fullData = table.getTableData().fullData
				let amount = 0
				fullData.forEach((item) => {
					amount += parseFloat(item.costamount?item.costamount:0)
				})
				this.fApi.setValue('amount', amount)
				return amount.toFixed(2)
			},
			
		},
		components: {
			bankaccbox,
			rcvaccbox,
			jindieform,
			invoiceConfig
		}
	}
</script>
